import React, { useCallback } from 'react';
import { MetadataContent } from '@jutro/uiconfig';
import { useTranslator } from '@jutro/locale';
import moment from 'moment';
import metadata from './AdacDocumentsList.metadata.json5';
import styles from './AdacDocumentsList.module.scss';

export default function DocumentsList({ data, showDocumentType = true}) {
    const translator = useTranslator();

    const getDocumentTypeCell = useCallback((item) => {
        return (
            <span>
                {translator({
                    id: `typekey.PortalDocumentType_Adac.${item.documentCategory_Adac}`,
                    defaultMessage: item.documentCategory_Adac
                })}
            </span>
        );
    }, [translator]);

    const getFilenameCell = useCallback((item) => {
        return (
            <span>{item.name}</span>
        );
    }, []);

    const getDateCell = useCallback((item) => {
        return (
            <span className={styles.documentName}>{moment(item.dateModified).format('DD.MM.YYYY H:mm')}</span>
        );
    }, []);

    const resolvers = {
        resolveComponentMap: {},
        resolveCallbackMap: {
            getDocumentTypeCell,
            getFilenameCell,
            getDateCell,
        }
    };

    const overrides = {
        documentsCategoryHeader: {
           visible: showDocumentType
        },
        documentsDateHeader: {
            header :{
                id: showDocumentType ?  "adac.my-documents-page.Date sent" :  "adac.my-documents-page.Receipt date"
            }
        },
        documentsTableGrid: {
            data
        }
    };

    return <MetadataContent
        uiProps={metadata.pageContent}
        overrideProps={overrides}
        {...resolvers}
    />;
}
